<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section', block.bgcolour]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <div class="columns">
            <div class="column is-8 is-offset-2">
                <h2 :class="['title', {'is-hidden': block.hide_title}]">{{block.title}}</h2>
                <div class="content" v-if="block.content" ref="content" v-html="block.content"></div>
                <form class="form contact-block__form content" method="post" @submit.prevent="submit">
                    <fieldset :disabled="is_loading">
                        <div class="field">
                            <div class="control">
                                <input class="input is-large" type="text" v-model="first_name" placeholder="First Name (*)" required />
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input class="input is-large" type="text" v-model="surname" placeholder="Last Name (*)" required />
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input class="input is-large" type="email" v-model="email" placeholder="Email (*)" required />
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input class="input is-large" type="text" v-model="company" placeholder="Company (*)" required />
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <textarea class="textarea" v-model="content" placeholder="How can we help? (*)" required></textarea>
                            </div>
                        </div>
                        <div class="field">
                            <div style="margin-bottom: 0.5rem;" class="control">
                                <!-- <label class="radio"><input type="radio" name="subscribed" :value="true" v-model="subscribed" /> Yes</label>
                                <label class="radio"><input type="radio" name="subscribed" :value="false" v-model="subscribed" /> No</label> -->
                                <div class="field__radio-buttons">
                                    <div class="control">
                                        <label class="checkbox"><input type="checkbox" name="subscribed" :value="true" v-model="subscribed" /> Yes - I would like to receive invites for webinars and workshops.</label>
                                    </div>
                                </div>
                            </div>
                            <p style="line-height: 1.6; letter-spacing: 0;">If you select yes, you can always unsubscribe from our mailouts.</p>
                        </div>
                        <div class="actions field">
                            <div class="columns is-vertical-centred">
                                <vue-recaptcha ref="recaptcha" @verify="verify" @expired="expired" class="column" :sitekey="block.site_key" :loadRecaptchaScript="true"></vue-recaptcha>
                                <div class="column is-narrow">
                                    <button type="submit" :class="['button bg-orange is-rounded', {'is-loading': is_loading}]">LET'S TALK</button>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
import VueRecaptcha from 'vue-recaptcha';
export default {
    name    :   'ContactBlock',
    mixins  :   [ BlockCommons ],
    components  :   { VueRecaptcha },
    data()
    {
        return {
            is_loading  :   false,
            first_name  :   null,
            surname     :   null,
            email       :   null,
            content     :   null,
            subscribed  :   false,
            recap_resp  :   null,
            company     :   null,
        };
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
    methods :
    {
        expired() {
            this.recap_resp =   false;
        },
        verify(resp) {
            this.recap_resp =   resp;
        },
        submit(e)
        {
            if (!this.recap_resp) {
                alert('Please verify you are not a robot!');
                return false;
            }

            if (this.is_loading) return false;
            this.is_loading =   true;

            let me      =   this,
                data    =   new FormData();

            data.append('csrf', csrf);
            data.append('first_name', this.first_name);
            data.append('surname', this.surname);
            data.append('content', this.content);
            data.append('email', this.email);
            data.append('subscribed', this.subscribed);
            data.append('recap_resp', this.recap_resp);
            data.append('company', this.company);
            if (localStorage.contactRefPage) {
                data.append('contact_ref', localStorage.contactRefPage)
            }
            axios.post(
                base_url + endpoints.contact,
                data
            ).then((resp) => {
                this.is_loading =   false;
                this.first_name =   null;
                this.surname    =   null;
                this.email      =   null;
                this.content    =   null;
                this.recap_resp =   null;
                this.subscribed =   false;
                this.$refs.recaptcha.reset();
                this.$bus.$emit('onShowMessage', resp.data.message, 'purple', 'Contact Message Sent');
            }).catch((error) => {
                this.is_loading =   false;
                this.$refs.recaptcha.reset();
                this.$bus.$emit('onShowMessage', error.response.data.message, 'danger', 'Contact Message Failed');
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/ContactBlock.vue